import { Component, EventEmitter, inject, Input, OnInit, Output } from "@angular/core";

import { timeZoneAbbreviation } from "@shared/utils/date.util";
import { Milestone } from "@shared/models/pay-cycle.interface";
import { FeatureManagementService } from "@shared/services/feature-management/feature-management.service";
import { FeatureFlagCodes } from "@shared/constants/feature-flag-codes";
import { take } from "rxjs";

@Component({
	selector: "milestone-details-row",
	templateUrl: "./milestone-details-row.component.html",
	styleUrls: ["./milestone-details-row.component.scss"]
})
export class MilestoneDetailsRowComponent implements OnInit {
	@Input() milestone: Milestone | undefined;

	showMilestonesState = false;

	@Input() set _showMilestonesState(val: boolean) {
		this.showMilestonesState = val;
	}

	@Output() onStatus: EventEmitter<void> = new EventEmitter<void>();
	@Output() onMenu: EventEmitter<void> = new EventEmitter<void>();
	@Output() cardClickedEvent: EventEmitter<void> = new EventEmitter<void>();
	@Output() viewIconClickedEvent: EventEmitter<void> = new EventEmitter<void>();

	timeZoneShort = "";
	hasBookingDate = false;
	hasTimezoneFeature = false;

	private featureManagementService = inject(FeatureManagementService);

	constructor() {
		this.timeZoneShort = timeZoneAbbreviation();

		this.featureManagementService
			.hasFeature(FeatureFlagCodes.Q3_TIMEZONE_FE)
			.pipe(take(1))
			.subscribe(hasFeature => (this.hasTimezoneFeature = hasFeature));
	}

	ngOnInit(): void {
		this.hasBookingDate =
			this.milestone?.extraInfo?.netBookingDate !== null &&
			this.milestone?.extraInfo?.netBookingDate !== undefined &&
			this.milestone?.type === "NETS";
	}
}
